import { Card, Col, Form, Row, Avatar, Button, Space, Flex, Breadcrumb, Modal, Result, ConfigProvider } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Switch } from 'antd';

import { ReactComponent as PackageIcon } from "../../../assets/icon/package.svg";
import { ReactComponent as Credit } from "../../../assets/icon/credit.svg";
import { ReactComponent as History } from "../../../assets/icon/history.svg";
import { ReactComponent as Login } from "../../../assets/icon/login.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";

import { Info } from "components/elements";
import { MainLayout } from "components/layouts";
import { CodeOutlined, UserOutlined } from "@ant-design/icons";
import AdminDetailForm from "./AdminDetailForm";
import dayjs from "dayjs";
import useAdminCompany from "../hooks/useAdminCompany";
import { useNavigate } from "react-router-dom";
import AdminCompanyCreditModal from "./AdminCompanyModal";
// import AdminCompanyPackageDetail from "./AdminCompanyPackagedetail";

const AdminDetail = ({
  companyInfo = () => { },
  modalProps = {},
  employeeOptions = [],
  onUpdateAdminCompanyInfo = () => { },
  onUpdateAdminCompanyStatusFlag = () => { },
  craditisModalOpen = () => { },
  setcraditIsModalOpen = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [creditModalOpen, setCreditModalOpen] = useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [openListEmployee, setOpenListEmployee] = useState(false);
  const navigate = useNavigate();

  const { onSelectCompany } = useAdminCompany();

  const handleUpdateAdminCompanyInfo = (values, onSuccess) => {
    onUpdateAdminCompanyInfo(values, async () => {
      await onSelectCompany(companyInfo?.id || companyInfo?.stpCompanyId);
      if (onSuccess) onSuccess();
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const calculatePeriod = (startDate) => {
    if (!startDate) return "";

    const start = dayjs(startDate);
    if (!start.isValid()) return "";

    const end = dayjs();
    const diffDays = end.diff(start, "day");

    const years = Math.floor(diffDays / 365);
    const months = Math.floor((diffDays % 365) / 30);
    const days = diffDays - (years * 365 + months * 30);

    if (years > 0) {
      return `${years} ${t("unit.years")} ${months > 0 ? months + " " + t("unit.months") : ""} ${days > 0 ? days + " " + t("unit.days") : ""}`;
    } else if (months > 0) {
      return `${months} ${t("unit.months")} ${days > 0 ? days + " " + t("unit.days") : ""}`;
    } else {
      return `${days} ${t("unit.days")}`;
    }
  };

  return (
    <MainLayout>
      {/* <Modal
        open={isModalOpen}
        onCancel={handleCancel}
        footer={false}
        maskClosable={false}
        {...modalProps}
      >
        <Result
          icon={<CodeOutlined />}
          title="Coming soon !"
        />
      </Modal> */}

      <AdminCompanyCreditModal
        isModalOpen={creditModalOpen}
        onCancel={() => setCreditModalOpen(false)}
        maskClosable={false}
      />

      {openListEmployee && (
        <Modal title={t("response_company.label.admin_list")}
          open={openListEmployee}
          onCancel={() => setOpenListEmployee(false)}
          footer={false}
          width="510px"
        >
          <Card size="small" style={{ border: "1px solid #000" }}>
            {companyInfo?.adminList?.map((employee, index) => (
              <div key={index}>
                {i18n.language === "en" ? employee?.fullnameEn : employee?.fullname}
              </div>
            ))}
          </Card>
        </Modal>
      )}

      <Space size={24} direction="vertical" style={{ width: "100%" }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("configuration.header"), href: "/admin/response_company" },
            { title: t("company_profile.header") },
            { title: t('employee.label.description') },
          ]} />
          <h2>{t("company_profile.header")}</h2>
          <span style={{ color: "#667085" }}>{t("response_company.label.company_info_detail")}</span>
        </Flex>

        <Row gutter={16} align="stretch" style={{ margin: "0px" }}>
          <ConfigProvider
            theme={{
              components: {
                Card: {
                  paddingLG: "16px"
                },
              },
            }}
          >
            <Col span={6} style={{ paddingLeft: "0px" }}>
              <Card
                style={{ borderRadius: "10px", border: "1px solid #D9D9D9", height: "100%" }}
                hoverable
                onClick={() => {
                  navigate("/");
                }}
              >
                <div style={{ display: "flex" }}>
                  <Avatar
                    size={60}
                    icon={<Login />}
                    style={{ backgroundColor: "#2CADE7", flexShrink: 0 }}
                  />

                  <div style={{ marginLeft: "8px" }}>
                    <span style={{ fontSize: "16px" }}>{t("response_company.label.log_in_to_admin")}</span>
                    <p style={{ fontSize: "13px", color: "#667085" }}>
                      {t("response_company.label.log_in_to_admin_detail")}
                    </p>
                  </div>
                </div>
              </Card>
            </Col>

            <Col span={6}>
              <Card style={{ borderRadius: "10px", border: "1px solid #D9D9D9", height: "100%" }} hoverable
                onClick={() => {
                  navigate("/admin/response_company/package_detail");
                }}
              >
                <div style={{ display: "flex" }}>
                  <Avatar
                    size={60}
                    icon={<PackageIcon />}
                    style={{ backgroundColor: "#2CADE7", flexShrink: 0 }}
                  />

                  <div style={{ marginLeft: "8px" }}>
                    <span style={{ fontSize: "16px" }}>{t("response_company.label.package_detail")}</span>
                    <p style={{ fontSize: "13px", color: "#667085" }}>
                      {t("response_company.label.package_detail_description")}
                    </p>
                  </div>
                </div>
              </Card>
            </Col>

            <Col span={6}>
              <Card style={{ borderRadius: "10px", border: "1px solid #D9D9D9", height: "100%" }} hoverable
                onClick={() => {
                  navigate("/admin/response_company/payment_history");
                }}
              >
                <div style={{ display: "flex" }}>
                  <Avatar
                    size={60}
                    icon={<History />}
                    style={{ backgroundColor: "#2CADE7", flexShrink: 0 }}
                  />

                  <div style={{ marginLeft: "8px" }}>
                    <span style={{ fontSize: "16px" }}>{t("response_company.label.payment_history")}</span>
                    <p style={{ fontSize: "13px", color: "#667085" }}>
                      {t("response_company.label.payment_history_detail")}
                    </p>
                  </div>
                </div>
              </Card>

            </Col>

            <Col span={6} style={{ paddingRight: "0px" }}>
              <Card
                style={{
                  borderRadius: "10px",
                  border: "1px solid #D9D9D9",
                  height: "100%",
                }}
                hoverable
                onClick={() => {
                  setCreditModalOpen(true);
                }}
              >
                <div style={{ display: "flex" }}>
                  <Avatar
                    size={60}
                    icon={<Credit />}
                    style={{ backgroundColor: "#2CADE7", flexShrink: 0 }}
                  />

                  <div style={{ marginLeft: "8px" }}>
                    <span style={{ fontSize: "16px" }}>
                      {t("response_company.label.credit_card_detail")}
                    </span>
                    <p style={{ fontSize: "13px", color: "#667085" }}>
                      {t("response_company.label.credit_card_detail_description")}
                    </p>
                  </div>
                </div>
              </Card>
            </Col>
          </ConfigProvider>
        </Row>

        <Row>
          <Card
            style={{
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
              width: "100%",
            }}
          >
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
              <Row justify="space-between" align="middle">
                <Flex vertical>
                  <span style={{ fontSize: "20px" }}>{t("response_company.label.company_detail")}</span>
                  <span style={{ color: "#667085" }}>
                    {t("response_company.label.company_detail_description")}
                  </span>
                </Flex>

                <Flex vertical gap={16} style={{ alignItems: "end" }}>
                  {!isEdit &&
                    <Button
                      type="primary"
                      style={{ width: "max-content", borderRadius: "8px", display: "flex", alignItems: "center", backgroundColor: "var(--button-color)", fontSize: "14px" }}
                      icon={<EditIcon style={{ fontSize: 14 }} />}
                      size="large"
                      onClick={() => setIsEdit(true)}
                    >
                      {t("common.edit")}
                    </Button>}
                  <Flex style={{ alignItems: "center", gap: "16px" }}>
                    <span style={{ color: "#42526D" }}>{t("response_company.label.status")}</span>
                    <Switch
                      checked={companyInfo?.statusFlag === "ACTIVE"}
                      onChange={(checked) => {
                        let active = checked ? "ACTIVE" : "INACTIVE"
                        onUpdateAdminCompanyStatusFlag(active);
                      }}
                    />
                  </Flex>
                </Flex>
              </Row>

              {isEdit ?
                <AdminDetailForm
                  setIsEdit={setIsEdit}
                  companyInfo={companyInfo}
                  employeeOptions={employeeOptions}
                  onUpdateAdminCompanyInfo={handleUpdateAdminCompanyInfo}
                />
                : <Flex vertical gap={16}>
                  {companyInfo?.logo ? (
                    <img
                      alt={companyInfo.companyName}
                      src={`data:image/png;base64,${companyInfo.logo}`}
                      style={{
                        width: 140,
                        height: 140,
                        objectFit: "contain",
                        borderRadius: "100%",
                        border: "1px solid #D9D9D9",
                        padding: 2,
                        backgroundColor: "#fff",
                        alignSelf: "center",
                      }}
                    />
                  ) : (
                    <UserOutlined
                      style={{
                        fontSize: 64,
                        color: "#fff",
                        border: "1px solid #D9D9D9",
                        borderRadius: "100%",
                        width: 140,
                        height: 140,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#D9D9D9",
                        alignSelf: "center",
                      }}
                    />
                  )}

                  <Row gutter={[16, 24]}>
                    <Col span={8}>
                      <Info
                        label={t("response_company.label.tax_id")}
                        value={<span style={{ color: "#42526D", fontWeight: "bold" }}>{companyInfo?.taxId ? companyInfo?.taxId : "-"}</span>}
                      />
                    </Col>
                    <Col span={8}>
                      <Info
                        label={t("company_profile.label.company_name_th")}
                        value={<span style={{ color: "#42526D", fontWeight: "bold" }}>{companyInfo?.companyName ? companyInfo?.companyName : "-"}</span>}
                      />
                    </Col>
                    <Col span={8}>
                      <Info
                        label={t("company_profile.label.company_name_en")}
                        value={<span style={{ color: "#42526D", fontWeight: "bold" }}>{companyInfo?.companyNameEn ? companyInfo?.companyNameEn : "-"}</span>}
                      />
                    </Col>
                    <Col span={8} >
                      <Info
                        label={t("response_company.label.careTaker")}
                        value={<span style={{ color: "#42526D", fontWeight: "bold" }}>{companyInfo?.adminList?.length >= 1 ?
                          (<>
                            <span style={{ color: "#42526D" }} >
                              {companyInfo?.adminList?.map(admin => admin.fullname)?.slice(0, 2).join(", ")}
                            </span>
                            {companyInfo?.adminList?.length > 2 ? (
                              // eslint-disable-next-line jsx-a11y/anchor-is-valid
                              <a
                                onClick={(e) => {
                                  setOpenListEmployee(true);
                                }}
                                style={{
                                  display: "inline-block",
                                  borderRadius: "36px",
                                  padding: "4px 12px",
                                  fontSize: "0.7vw",
                                  color: "#fff",
                                  background: "var(--button-color)",
                                  textDecoration: "none",
                                  fontWeight: "bold",
                                  border: "1px solid var(--button-color)",
                                  cursor: "pointer",
                                  marginLeft: "4px"
                                }}

                              >
                                {`+ ${companyInfo?.adminList?.length - 2}`}
                              </a>
                            ) : ""}
                          </>) : "-"}</span>}
                      />
                    </Col>
                    <Col span={8}>
                      <Info
                        label={t("response_company.label.start_date")}
                        value={<span style={{ color: "#42526D", fontWeight: "bold" }}>
                          {i18n.language == "en"
                            ? dayjs(companyInfo?.startDateInFlowHr)?.format("DD/MM/YYYY")
                            : dayjs(companyInfo?.startDateInFlowHr)?.format("DD/MM/BBBB")}</span>}
                      />
                    </Col>
                    <Col span={8}>
                      <Info
                        label={t("response_company.label.exp_date")}
                        value={<span style={{ color: "#42526D", fontWeight: "bold" }}>{companyInfo?.expiredDate ? companyInfo?.expiredDate : "-"}</span>}
                      />
                    </Col>
                    <Col span={8}  >
                      <Info
                        label={t("response_company.label.total_use")}
                        value={<span style={{ color: "#42526D", fontWeight: "bold" }}>{companyInfo?.startDateInFlowHr ? calculatePeriod(companyInfo?.startDateInFlowHr) : "-"}</span>}
                      />
                    </Col>
                    <Col span={8}>
                      <Info
                        label={t("response_company.label.remaining")}
                        value={<span style={{ color: "#42526D", fontWeight: "bold" }}>{companyInfo?.remainingTime ? companyInfo?.remainingTime : "-"}</span>}
                      />
                    </Col>
                    <Col span={8}>
                      <Info
                        label={t("number-of-employees")}
                        value={<span style={{ color: "#42526D", fontWeight: "bold" }}>{(companyInfo?.countEmployee || 0).toLocaleString()}</span>}
                      />
                    </Col>
                  </Row>
                </Flex>}
            </Space>
          </Card>
        </Row>
      </Space>
    </MainLayout>
  );
};

export default AdminDetail;
